<template>
  <div>
    <div class="field is-grouped is-grouped-centered">
      <div v-if="videoIsUp && !imageTaken" class="control">
        <button class="button is-success" @click.prevent="capture">
          Capture
        </button>
      </div>
      <div v-if="videoIsUp && imageTaken" class="control">
        <button class="button is-success" @click.prevent="save">
          Save
        </button>
      </div>
      <div v-if="videoIsUp && !imageTaken && devices.length > 1" class="control">
        <button class="button is-light" @click.prevent="switchCamera">
          Switch
        </button>
      </div>
      <div v-if="videoIsUp && imageTaken" class="control">
        <button class="button is-link" @click.prevent="reset">
          Reset
        </button>
      </div>
      <div class="control">
        <button class="button" @click.prevent="cancel">
          Cancel
        </button>
      </div>
    </div>
    <div class="level">
      <div class="level-item has-text-centered" v-if="captureMode && !imageTaken">
        <video ref="video" @canplay.once="canPlay" :width="picWidth" :height="picHeight"></video>
      </div>
      <div v-if="captureMode && imageTaken" ref="output" class="level-item has-text-centered">
        <img ref="photo" :src="photoSrc">
      </div>
    </div>
    <canvas ref="canvas" class="canvas" :width="picWidth" :height="picHeight"></canvas>
    <div class="notification is-danger" v-if="flash">{{flash}}</div>
  </div>
</template>

<script>
const PIC_WIDTH = 320;

export default {
  name: 'image-capture',
  data() {
    return {
      captureMode: true,
      videoIsUp: false,
      imageTaken: false,
      flash: null,

      picWidth: 1,
      picHeight: 1,

      photoSrc: null,
      mediaTrack: null,

      devices: [],
      currentDevice: null,
    };
  },
  mounted() {
    navigator.mediaDevices.enumerateDevices()
      .then((devices) => {
        devices.forEach((device) => {
          // console.log(`${device.kind}: ${device.label} id=${device.deviceId}`);
          if (device.kind.match(/video/i)) {
            this.devices.push(device);
          }
        });

        if (this.devices.length) {
          this.currentDevice = 0;
          this.startVideo();
        }
      });
  },
  methods: {
    startVideo() {
      navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          deviceId: this.devices[this.currentDevice].deviceId,
        },
      }).then((stream) => {
        this.$refs.video.srcObject = stream;
        this.$refs.video.play();
        this.mediaTrack = stream.getTracks()[0];
        this.captureMode = true;
      }).catch((err) => {
        this.flash = `Error: ${err.message}`;
      });
    },
    capture() {
      const canvas = this.$refs.canvas;
      const context = canvas.getContext('2d');
      context.drawImage(this.$refs.video, 0, 0, this.picWidth, this.picHeight);

      const data = canvas.toDataURL('image/png');
      this.photoSrc = data;

      this.mediaTrack.stop();
      this.imageTaken = true;
    },
    save() {
      this.$emit('save', {
        data: this.photoSrc,
        width: this.picWidth,
        height: this.picHeight,
      });
      this.reset();
    },
    switchCamera() {
      this.currentDevice = (this.currentDevice + 1) % this.devices.length;
      this.mediaTrack.stop();
      this.startVideo();
    },
    reset() {
      this.videoIsUp = false;
      this.clearPhoto();
      this.startVideo();
    },
    cancel() {
      this.clearPhoto();
      this.captureMode = false;
      this.videoIsUp = false;
      this.mediaTrack.stop();
      this.$emit('cancel');
    },
    canPlay() {
      if (this.captureMode) {
        const video = this.$refs.video;
        this.picHeight = video.videoHeight / (video.videoWidth / PIC_WIDTH);
        this.picWidth = PIC_WIDTH;
        this.videoIsUp = true;
      }
    },
    clearPhoto() {
      // Clear the canvas - set to grey box
      const canvas = this.$refs.canvas;
      const context = canvas.getContext('2d');
      context.fillStyle = '#AAA';
      context.fillRect(0, 0, canvas.width, canvas.height);

      // If we had a separate box on the screen for the captured image,
      // then this would clear it, but we don't
      // const data = canvas.toDataURL('image/png');
      // this.photoSrc = data;  <-- this would be the other image capture window

      this.photoSrc = null;
      this.imageTaken = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.canvas
  display: none

</style>



// WEBPACK FOOTER //
// src/components/ImageCapture.vue